export default __webpack_public_path__ + "static/modal-background-pubertad@2x-9533bdbd0ae6ec250608d1f95c41a517.png";